import { Box } from '@mui/material';

const UIBox = Box;
export default UIBox;
